var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("这是什么，字体,呢")]),_c('p',{staticClass:"p"},[_vm._v("这是什么，字体,呢")])])}]

export { render, staticRenderFns }